import React from 'react';
import { theme } from '../theme';

// ─── CategoryVocabularyMissingNotice ────────────────────
// <purpose>Shared empty-state REPLACEMENT for stats surfaces when cm.vocabularyMissing is true —
// a KNOWN role (config resolved fine, no global RoleConfigWarning) whose tenant has neither a
// classification schema nor vocabulary loaded yet (e.g. freshly-provisioned VNB before taxonomy
// seeding). Without this, categoryKeys=[] renders the surface's generic "Keine Daten" text,
// indistinguishable from a genuinely empty dataset — the silent-empty state the placeholder floor
// forbids. Same shape (minHeight, centered, textSecondary) as each surface's normal empty state so
// swapping this in never shifts layout (UI Layout Stability Rule) — only the text differs.</purpose>
export const CategoryVocabularyMissingNotice: React.FC<{ minHeight?: number }> = ({ minHeight = 120 }) => (
  <div style={{
    minHeight, display: 'flex', alignItems: 'center', justifyContent: 'center',
    color: theme.colors.textSecondary, fontSize: 13, textAlign: 'center', padding: '0 12px',
  }}>
    Rollenkonfiguration unvollständig — keine Klassifizierungsdaten verfügbar.
  </div>
);
